import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import EventIcon from '@material-ui/icons/Event';
import FlightIcon from '@material-ui/icons/Flight';
import TurnedInNotIcon from '@material-ui/icons/TurnedInNot';
import DomainIcon from '@material-ui/icons/Domain';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import PersonIcon from '@material-ui/icons/Person';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import CachedIcon from '@material-ui/icons/Cached';
const IconMenu = ({ icon }) => {
    switch (icon) {
        case "0":
            return <EventIcon />; //Icono Calendario
        case "1":
            return <DomainIcon />; //Icono Empresa
        case "2":
            return <SupervisorAccountIcon />; //Usuario Proveedor
        case "3":
            return <FlightIcon />; //Icono Paquetes
        case "4":
            return <AccountBoxIcon /> //Icono Roles
        case "5":
            return <PersonIcon /> //Icono Usuarios
        case "6":
            return <AccountBalanceIcon /> //Icono pagos
        case "7":
            return <MonetizationOnIcon /> //Icono Comisiones
        case "8":
            return <EqualizerIcon /> //ICono reporte
        case "9":
            return <AccountBalanceWalletIcon /> //Icono finanzas
        case "10":
            return <CachedIcon /> //Icono Cambios
        default:
            return <TurnedInNotIcon /> //Icono default
    }
}
export default IconMenu